import api from '../laravelAxiosClient';
import {
  CreatePdfFacturePayload,
  CreatePdfFactureResult,
  CreateStripeCheckoutSessionPourFacturePayload,
  CreateStripeCheckoutSessionPourFactureResult,
  FactureDownloadUrlResult,
  FactureResult,
  FacturesAPayerResult,
  FacturesResult,
} from '@/lib/interfaces/factures.interface';

export const facturesService = {
  getFactures: async () => {
    const { data } = await api.get<FacturesResult>("/factures/mes-factures");
    return data;
  },
  getFacture: async (factureId: string) => {
    const { data } = await api.get<FactureResult>(`/factures/${factureId}`);
    return data;
  },
  getFacturesAPayer: async () => {
    const { data } = await api.get<FacturesAPayerResult>("/factures/a-payer");
    return data;
  },
  getDownloadUrl: async (factureId: string) => {
    const { data } = await api.get<FactureDownloadUrlResult>(`/factures/${factureId}/download-url`);
    return data;
  },
  createPdf: async (payload: CreatePdfFacturePayload) => {
    const { data } = await api.post<CreatePdfFactureResult>("/factures/creer-pdf", payload);
    return data;
  },
  createStripeCheckoutSessionPourFacture: async (payload: CreateStripeCheckoutSessionPourFacturePayload) => {
    const { data } = await api.post<CreateStripeCheckoutSessionPourFactureResult>(
      "/paiement/creer-stripe-checkout-session-pour-facture",
      payload,
    );
    return data;
  },
};
